export * from './mock-categories'; // Legacy i18n-based categories
export * from './example-categories'; // New DB-based categories with nameEn/nameFr
